module.exports = __webpack_public_path__ + "static/media/polaroids-512.4e278877.png";